module.exports = __webpack_public_path__ + "static/media/logo-knmi.3a35ca4d.svg";